import { createNativeStackNavigator } from '@react-navigation/native-stack';
import _ from "lodash";
import { AppRoutes } from "navigations/app-routes";
import React from 'react';
import ManagementCreditBundleGroupScene from 'scenes/management/credit_bundles';
import ManagementCreditBundlesIndex from 'scenes/management/credit_bundles/_tabs/bundle';
import ManagementCreditBundlesEdit from 'scenes/management/credit_bundles/_tabs/bundle_edit';
import ManagementCreditQrEdit from 'scenes/management/credit_bundles/_tabs/qr_edit';
import { stackProps } from "utils/helper-navigation";
import { createPageTitle } from 'utils/helper-page-title';
import HelperString from "utils/helper-string";

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_CREDIT_BUNDLES]: {
		component: ManagementCreditBundleGroupScene,
	},
	[AppRoutes.MANAGEMENT_CREDIT_BUNDLES_EDIT]: {
		component: ManagementCreditBundlesEdit,
	},
	[AppRoutes.MANAGEMENT_CREDIT_BUNDLES_QR_EDIT]: {
		component: ManagementCreditQrEdit,
	}
}

const ManagementCreditBundlesNavigator = ( props ) => {
	return (
		<Stack.Navigator
			initialRouteName={ AppRoutes.MANAGEMENT_CREDIT_BUNDLES }
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementCreditBundlesNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementCreditBundlesNavigator
